module.exports = __webpack_public_path__ + "media/theme/itunes__tutorial--1-fc946581.png";